import { defineStore } from 'pinia'

import { createOperatorReportingActions } from './actions'
import { createOperatorReportingState } from './state'

export const useOperatorReportingV2Store = defineStore('reportsV2OperatorReporting', () => {
    const state = createOperatorReportingState()
    const actions = createOperatorReportingActions(state)

    return {
        ...state,
        ...actions
    }
})
